module.exports = __webpack_public_path__ + "static/media/star.2428df16.svg";